import ClipboardIcon from "lucide-react/dist/esm/icons/clipboard";
import * as Icons from "lucide-react";

export const getRecordIcon = (icon?: string, source?: string) => {
  if (icon) {
    let IconComponent = ClipboardIcon;
    try {
      if (icon && icon in Icons) {
        IconComponent = Icons[icon as keyof typeof Icons] as typeof ClipboardIcon;
      }
      return <IconComponent className="h-4 w-4" />;
    } catch (err) {
      console.log(err);
    }
  } else if (source) {
    if (source === "job") {
      return <Icons.Briefcase className="h-4 w-4" />;
    } else if (source === "client") {
      return <Icons.Building className="h-4 w-4" />;
    } else if (source === "application") {
      return <Icons.FileText className="h-4 w-4" />;
    } else if (source === "candidate") {
      return <Icons.Users className="h-4 w-4" />;
    } else if (source === "contact") {
      return <Icons.User className="h-4 w-4" />;
    } else if (source === "user") {
      return <Icons.ShieldUser className="h-4 w-4" />;
    } else if (source === "automation") {
      return <Icons.Workflow className="h-4 w-4" />;
    }
    return <ClipboardIcon className="h-4 w-4" />;
  }
};
